import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SafeHtmlPipe } from "./safe-html/safe-html.pipe";
import { HighlightPipe } from "./highlight/highlight.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [
    HighlightPipe,
    SafeHtmlPipe
  ],
  exports: [
    HighlightPipe,
    SafeHtmlPipe
  ],
})
export class UigPipesModule {}
